
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  IconButton,
  Alert,
  CircularProgress,
  Typography,
} from '@mui/material';
import RemoveCircleOutlineIcon from '@mui/icons-material/Delete';
import { removeUserRoots } from '../../../../../services/Users';
import { fetchActiveBranches } from '../../../../../services/dashboard/apiServiceDashboard';

const RemoveUserRootButton = ({ userId, onSuccess }) => {
  const [open, setOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false); // ✅ Dialog تأكيد منفصل
  const [branches, setBranches] = useState([]);
  const [rootId, setRootId] = useState('');
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleOpen = async () => {
    setMessage(null);
    setRootId('');
    setOpen(true);
    setLoading(true);
    try {
      const data = await fetchActiveBranches();
      setBranches(data);
    } catch (err) {
      setMessage({ type: 'error', text: '❌ فشل في تحميل الفروع: ' + err.message });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setMessage(null);
    setRootId('');
  };

  const handleConfirmClose = () => {
    setConfirmDialogOpen(false);
  };

  const handleRemove = async () => {
    setMessage(null);
    try {
      await removeUserRoots(userId, [parseInt(rootId)]);
      setMessage({ type: 'success', text: '✅ تم إلغاء ربط الفرع بنجاح' });
      if (onSuccess) onSuccess();
      setConfirmDialogOpen(false);
      handleClose();
    } catch (err) {
      setMessage({ type: 'error', text: err.message });
    }
  };

  return (
    <>
      <IconButton color="error" onClick={handleOpen}>
        <RemoveCircleOutlineIcon />
      </IconButton>

      {/* Dialog اختيار الفرع */}
      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle>🗑️ إلغاء ربط فرع من المستخدم</DialogTitle>
        <DialogContent>
          {loading ? (
            <CircularProgress />
          ) : (
            <FormControl fullWidth margin="normal">
              <InputLabel>اختر الفرع</InputLabel>
              <Select
                value={rootId}
                onChange={(e) => setRootId(e.target.value)}
                label="اختر الفرع"
              >
                {branches.map((branch) => (
                  <MenuItem key={branch.id} value={branch.id}>
                    {branch.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {message && (
            <Alert severity={message.type} sx={{ mt: 2 }}>
              {message.text}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>إلغاء</Button>
          <Button
            onClick={() => setConfirmDialogOpen(true)}
            color="error"
            variant="contained"
            disabled={!rootId}
          >
            تأكيد الحذف
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog تأكيد الحذف */}
      <Dialog open={confirmDialogOpen} onClose={handleConfirmClose}>
        <DialogTitle>⚠️ تأكيد الحذف</DialogTitle>
        <DialogContent>
          <Typography>
            هل أنت متأكد أنك تريد إلغاء ربط هذا الفرع من المستخدم؟
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmClose}>لا</Button>
          <Button onClick={handleRemove} color="error" variant="contained">
            نعم، احذف
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RemoveUserRootButton;
